import React, { useState } from 'react';
import { jwtDecode } from 'jwt-decode';

// ─── Datos del roadmap ───────────────────────────────────────────────────────

const ROADMAP_USER = [
  {
    version: 'Próximamente',
    estado: 'pendiente',
    fecha: null,
    items: [
        'Posibilidad de exportar una conversación de un ticket a PDF.',
        'Sistema de valoración de técnicos al cerrar un ticket.',
        'Sistema de tareas recurrentes.',
    ],
  },
  {
    version: 'v1.3.1',
    estado: 'publicada',
    fecha: 'Mar 2026',
    items: [
      'Corrección de errores reportados y mejoras de fiabilidad en reapertura de tickets.',
    ],
  },
    {
    version: 'v1.3.0',
    estado: 'pasada',
    fecha: 'Mar 2026',
    items: [
      'Optimización del rendimiento para cargas y navegación más rápidas.',
      'Corrección de errores reportados y mejoras de fiabilidad.',
      'Funcionalidad de creación de ticket para tu usuario vía telefónica (guía de onboarding).',
    ],
  },
];

const ROADMAP_INTERNO = [
  {
    version: 'v1.3.0',
    estado: 'publicada',
    fecha: 'Mar 2026',
    items: [
      'Mejoras significativas en la gestión interna para que el equipo pueda trabajar más rápido y con menos errores.',
      'Permitir a técnicos y administradores crear cuentas de usuario desde el panel de administración.',
      'Capacidad para que técnicos creen un ticket directamente para un usuario específico (gestión asistida).',
      'Creación y publicación del roadmap interno para coordinar mejoras y tareas del equipo.',
    ],
  },
];

// ─── Badges por estado ───────────────────────────────────────────────────────

const ESTADO_META = {
  publicada:     { label: 'Publicada',     cls: 'roadmap-badge--publicada' },
  'en-desarrollo': { label: 'En desarrollo', cls: 'roadmap-badge--desarrollo' },
  pendiente:     { label: 'Próximamente',   cls: 'roadmap-badge--pendiente' },
  pasada:        null,
};

// ─── Componente lista de versiones con línea temporal ───────────────────────

const RoadmapLista = ({ data }) => (
  <div className="roadmap-timeline">
    {data.map((bloque, idx) => {
      const meta = ESTADO_META[bloque.estado] !== undefined ? ESTADO_META[bloque.estado] : ESTADO_META.publicada;
      const esUltimo = idx === data.length - 1;
      return (
        <div key={bloque.version} className={`roadmap-timeline-entrada${esUltimo ? ' roadmap-timeline-entrada--ultimo' : ''}`}>
          {/* Marcador lateral */}
          <div className="roadmap-timeline-lateral">
            <div className={`roadmap-timeline-nodo roadmap-timeline-nodo--${bloque.estado}`} />
            {!esUltimo && <div className="roadmap-timeline-linea" />}
          </div>

          {/* Tarjeta */}
          <div className={`roadmap-bloque roadmap-bloque--${bloque.estado}`}>
            <div className="roadmap-bloque-header">
              <div className="roadmap-bloque-header-izq">
                <span className="roadmap-version">{bloque.version}</span>
                {meta && <span className={`roadmap-badge ${meta.cls}`}>{meta.label}</span>}
              </div>
              {bloque.fecha && (
                <span className="roadmap-fecha">{bloque.fecha}</span>
              )}
            </div>
            <ul className="roadmap-items">
              {bloque.items.map((item, i) => (
                <li key={i} className="roadmap-item">
                  <span className="roadmap-item-dot" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      );
    })}
  </div>
);

// ─── Componente principal ────────────────────────────────────────────────────

const Roadmap = () => {
  const token = localStorage.getItem('AuthToken');
  const tokenInfo = token ? jwtDecode(token) : {};
  const esInterno = tokenInfo.role === 'admin' || tokenInfo.role === 'tecnico';

  const [tabActivo, setTabActivo] = useState('user');

  return (
    <main className="roadmap-page site-width">
      <div className="roadmap-cabecera">
        <h1 className="roadmap-titulo">Roadmap de la plataforma</h1>
        <p className="roadmap-subtitulo">
          Consulta las mejoras publicadas, las que están en desarrollo y las que están planificadas.
        </p>
      </div>

      {esInterno ? (
        <>
          <div className="roadmap-tabs">
            <button
              className={tabActivo === 'user' ? 'active' : ''}
              onClick={() => setTabActivo('user')}
            >
              Roadmap para usuarios
            </button>
            <button
              className={tabActivo === 'interno' ? 'active' : ''}
              onClick={() => setTabActivo('interno')}
            >
              Roadmap interno
            </button>
          </div>
          <div className="tabcontent">
            {tabActivo === 'user'    && <RoadmapLista data={ROADMAP_USER} />}
            {tabActivo === 'interno' && <RoadmapLista data={ROADMAP_INTERNO} />}
          </div>
        </>
      ) : (
        <RoadmapLista data={ROADMAP_USER} />
      )}
    </main>
  );
};

export default Roadmap;
